import { Typography } from '@mui/material';
import React from 'react';
import { Root, StyledPaper } from '../../components/styles/styles';
import BackendService from 'BackendService';
import { NavigateFunction, useNavigate } from 'react-router-dom';

interface State {
  loading: boolean;
  invitationValid?: boolean;
  error: string | null;
  complete: boolean;
}

class CreateAdminUser extends React.Component<
  { invitationToken: string; navigate: NavigateFunction },
  State
> {
  constructor(props: { invitationToken: string; navigate: NavigateFunction }) {
    super(props);
    this.state = {
      loading: true,
      error: null,
      complete: false,
    };
  }

  componentDidMount(): void {
    const { invitationToken, navigate } = this.props;

    if (!invitationToken) {
      this.setState({
        loading: false,
        invitationValid: false,
        error: 'This link seems to be invalid, please contact support for help.',
      });
      return;
    }

    new BackendService()
      .validateAdminInvitationToken(invitationToken)
      .then(({ valid }) => {
        this.setState({
          loading: false,
          invitationValid: valid,
          complete: valid,
        });

        return new Promise((resolve) => {
          setTimeout(() => {
            if (valid) {
              navigate('/');
            }
            resolve(true);
          });
        });
      })
      .catch(() => {
        const error = 'Unable to verify link, please contact support.';

        this.setState({ loading: false, invitationValid: false, error });
      });
  }

  render() {
    const { loading, invitationValid, error, complete } = this.state;

    if (loading) {
      return (
        <Root>
          <StyledPaper>
            <Typography>Verifying admin invitation...</Typography>
          </StyledPaper>
        </Root>
      );
    }

    if (!invitationValid) {
      return (
        <Root>
          <StyledPaper>
            <Typography color="error">{error}</Typography>
          </StyledPaper>
        </Root>
      );
    }

    if (complete) {
      return (
        <Root>
          <StyledPaper>
            <Typography>Account created! Redirecting to login page...</Typography>
          </StyledPaper>
        </Root>
      );
    }
  }
}

const CreateAdminUserWithNavigate = (props: { invitationToken: string }) => {
  const navigate = useNavigate();

  return <CreateAdminUser {...props} navigate={navigate} />;
};

export default CreateAdminUserWithNavigate;
